export const business = {
  name: 'South Lyon Fence',
  since: '1983',
  address: {
    street: '53583 Grand River',
    city: 'New Hudson',
    state: 'MI',
    zip: '48165',
  },
  phone: '(248) 437-4445',
  phoneHref: 'tel:+12484374445',
  tollFree: '(800) 535-2472',
  tollFreeHref: 'tel:+18005352472',
  email: 'information@southlyonfence.com',
  productionUrl: 'https://www.southlyonfence.com/',
  states: ['Michigan', 'Indiana', 'Ohio'],
}

export const mapsHref =
  'https://www.google.com/maps/search/?api=1&query=' +
  encodeURIComponent('53583 Grand River, New Hudson, MI 48165')

export const mailtoHref =
  `mailto:${business.email}?subject=` + encodeURIComponent('Project inquiry')

export const assets = {
  logo: 'https://drwzpk38qkpfb.cloudfront.net/www.southlyonfence.com/uploaded/images/Redesign/logo.png',
  // Generated illustrative imagery for the homepage preview; not documented client projects.
  hero: 'https://cdn.magicpatterns.com/uploads/fKsEbZnwYzMCG2XaNNEFca/hero-utility-v4.jpg',
  industries: 'https://cdn.magicpatterns.com/uploads/ex5QukvUk2adfTLpV1zKQe/who-we-serve-v4.jpg',
  safety: 'https://cdn.magicpatterns.com/uploads/3mDa7Mgy8qV4xD1Td3woB5/safety-brightened-v4.jpg',
  fencingProject: 'https://drwzpk38qkpfb.cloudfront.net/www.southlyonfence.com/uploaded/images/Redesign/FENCING.jpg',
  fenceAlt:
    'https://drwzpk38qkpfb.cloudfront.net/www.southlyonfence.com/uploaded/images/Redesign/FENCING%202.jpg',
  specialty:
    'https://drwzpk38qkpfb.cloudfront.net/www.southlyonfence.com/uploaded/images/Redesign/speciality%201.jpg',
  temporary:
    'https://cdn.magicpatterns.com/uploads/xcDifAgFdCrL1ts9o2ccJt/temporary-screen-repaired-v6.jpg',
  worksite:
    'https://drwzpk38qkpfb.cloudfront.net/www.southlyonfence.com/uploaded/images/Redesign/20151013_080100%201.png',
  building:
    'https://cdn.magicpatterns.com/uploads/4iSrDAGjkE8bgfJ1Dq7A9y/building-sunny-v7.jpg',
}

export const navLinks = [
  { label: 'Services', href: '#services' },
  { label: 'Who we serve', href: '#industries' },
  { label: 'Safety', href: '#safety' },
  { label: 'About', href: '#about' },
]

export const proofItems = [
  {
    headline: `Since ${business.since}`,
    sublabel: 'Serving Southeastern Michigan since 1983.',
  },
  {
    headline: 'Michigan, Indiana & Ohio',
    sublabel: 'Based in New Hudson, Michigan.',
  },
  {
    headline: 'Utility & commercial projects',
    sublabel: 'Fencing, gates and specialty perimeter protection.',
  },
]

export type Service = {
  number: string
  title: string
  body: string
  detail: string[]
  cta: string
  image: string
  alt: string
  width: number
  height: number
}

export const services: Service[] = [
  {
    number: '01',
    title: 'Fencing & gates',
    body: 'Fence systems and custom gates for utility and commercial sites, with design-build and fabrication support.',
    detail: [
      'Chain link and mini chain link systems',
      'Specialty steel and ornamental fencing',
      'Custom gate fabrication and design-build support',
    ],
    cta: 'Discuss fencing & gates',
    image: assets.fencingProject,
    alt: 'Chain link fence line with steel posts installed along a utility site perimeter',
    width: 1328,
    height: 747,
  },
  {
    number: '02',
    title: 'Specialty perimeter protection',
    body: 'Work with our team to discuss screening and ballistic-rated fence options for your project requirements.',
    detail: [
      'Screening to limit visibility of site equipment',
      'Ballistic-rated fence options for specified projects',
      'Support for substation design teams',
    ],
    cta: 'Review perimeter requirements',
    image: assets.specialty,
    alt: 'Fence panel section with screening installed to limit visibility through the perimeter',
    width: 640,
    height: 380,
  },
  {
    number: '03',
    title: 'Temporary fencing',
    body: 'Temporary fencing for commercial and utility construction. Share your site requirements with our team to discuss the options.',
    detail: [
      'Commercial construction sites',
      'Utility construction projects',
      'Discuss your layout, access needs and duration',
    ],
    cta: 'Plan temporary fencing',
    image: assets.temporary,
    alt: 'Fence line with black screening beside a paved access route',
    width: 1448,
    height: 1086,
  },
]

export const industries = [
  {
    title: 'Electrical substations',
    body: 'Fencing, gates and specialty perimeter protection for substation projects.',
  },
  {
    title: 'Power plants',
    body: 'Fence and gate systems for power-generation facilities.',
  },
  {
    title: 'Gas transmission sites',
    body: 'Perimeter protection for gas transmission facilities.',
  },
  {
    title: 'Natural gas gate & valve sites',
    body: 'Discuss fencing, gate and screening requirements for your natural gas site.',
  },
  {
    title: 'Commercial construction',
    body: 'Fencing, gates and temporary perimeter options for commercial contractors.',
  },
]

export const safetyPractices = [
  {
    title: 'Daily toolbox talks',
    body: 'Toolbox talks are part of our daily safety practices.',
  },
  {
    title: 'Weekly equipment inspections',
    body: 'Our equipment receives weekly safety inspections.',
  },
  {
    title: 'Flame-resistant uniforms',
    body: 'We provide the FR uniforms our crews need for the job.',
  },
]

export const faqs = [
  {
    question: 'Which areas do you serve?',
    answer:
      'We work across Michigan, Indiana and Ohio from our location in New Hudson, Michigan.',
  },
  {
    question: 'What information should I share?',
    answer:
      'Share the site location, project stage, fence or gate requirements, and any drawings or specifications you have. Approximate fence lengths and gate openings are also helpful.',
  },
  {
    question: 'Do you offer specialty perimeter options?',
    answer:
      'Yes. We offer screening to limit visibility of equipment and ballistic-rated fence options. Contact our team to discuss the requirements for your project.',
  },
  {
    question: 'Do you install residential fencing?',
    answer:
      'No. South Lyon Fence focuses its installation work on utility and commercial projects.',
  },
]

export const preparationList = [
  'Project location and site access points',
  'Current project stage',
  'Site layout, plans or specification documents',
  'Fence or gate type under consideration',
  'Approximate linear footage and gate openings',
  'Known site requirements or protection specifications',
]

